<script setup>

import {computed, onMounted, ref} from "vue";
import { useNotificationStore } from '@/stores/NotificationStore.js'
const notificationStore = useNotificationStore()
const services = ref({})
const emit = defineEmits(['usingConferencing'])

const loadSettings = async () => {
    const res = await axios.get(route('integrations.cronofy.conferencing'))

    services.value = res.data.services
    emit('usingConferencing', enabledServices.value.length > 0)
}

const setMode = async (mode) => {
    const modes = {
        disable: route('integrations.cronofy.setup_conferencing', 'disable'),
        default: route('integrations.cronofy.setup_conferencing', 'default'),
        external: route('integrations.cronofy.setup_conferencing', 'external')
    }

    const res = await axios.get(modes[mode])

    if (res.data.url) {
        window.location = res.data.url
    } else if(res.data.success === true) {

    } else {
        notificationStore.addNotification({
            type: 'error',
            title: _mft('error:error.generalTryAgain'),
            dismissAfter: 0,
        })
        alert('Something went wrong: ' + res.data.message)
    }

    await loadSettings();
}

const availableServices = computed(() => {
    return Object.values(services.value).filter(service => service.available === true && service.enabled === false)
})

const enabledServices = computed(() => {
    return Object.values(services.value).filter(service => service.enabled === true)
})

onMounted(() => {
    loadSettings()
})

</script>

<template>
<div>
    <div
        v-if="enabledServices.length === 0"
    >
        <slot name="disabled"></slot>
    </div>
    <div
        v-if="enabledServices.length > 0"
        class="mb-4 pb-2 border-b"
    >
        <input-label :label="_mft('shared:active')"></input-label>

        <ul class="space-y-2">
            <li
                v-for="(service, i) in enabledServices"
                class="flex justify-between space-x-2 items-center"
            >
                <h5>{{ service.label }}</h5>
                <button-secondary
                    v-if="! service.enabled"
                    size="sm"
                    @click="setMode(service.mode)"
                >
                    {{ _mft('shared:action.use') }}
                </button-secondary>
                <span
                    v-else
                    class="flex space-x-2 items-center text-xs"
                >
                    <button-danger
                        size="sm"
                        @click="setMode('disable')"
                    >
                        {{ _mft('shared:action.disable') }}
                    </button-danger>
                </span>
            </li>
        </ul>
    </div>
    <div>
        <input-label :label="_mft('cronofy:conferencing.availableOptions')"></input-label>
        <ul class="space-y-2">
            <li
                v-for="(service, i) in availableServices"
                class="flex justify-between space-x-2 items-center"
            >
                <h5>{{ service.label }}</h5>
                <button-secondary
                    v-if="! service.enabled"
                    size="sm"
                    @click="setMode(service.mode)"
                >
                    {{ _mft('shared:action.use') }}
                </button-secondary>
                <span
                    v-else
                    class="flex space-x-2 items-center text-xs"
                >
                    <button-warning
                        size="sm"
                        @click="setMode('disable')"
                    >
                        {{ _mft('shared:action.disable') }}
                    </button-warning>
                </span>
            </li>
        </ul>
    </div>
</div>
</template>

<style scoped>

</style>
